{
  "en": {
    "timestamp": {
      "labels": {
        "accepted": "Accepted {date}",
        "ago": "ago",
        "daysAgo": "{days} day |{days} days",
        "daysRemaining": "{days} days remaining",
        "deadlineDaysLeft": "{days} days left",
        "deadlineOverdue": "Overdue",
        "due": "Due {date}",
        "dueToday": "Due today",
        "dueWas": "Due {date}",
        "expired": "Expired {date}",
        "hoursAgo": "{hours} hour | {hours} hours",
        "in": "In {time}",
        "justNow": "Just now",
        "minutesAgo": "{minutes} minute | {minutes} minutes",
        "monthsAgo": "{months} month | {months} months",
        "noDeadline": "No deadline set",
        "overdue": "Overdue with {days} days",
        "sentOn": "Sent on {date}",
        "sentOnAt": "Sent on {date} at {time}",
        "starts": "Starts {date}",
        "today": "Today",
        "tomorrow": "Tomorrow",
        "uploaded": "Uploaded {date}",
        "weeksAgo": "{weeks} week | {weeks} weeks",
        "yearsAgo": "{years} year | {years} years",
        "yesterday": "Yesterday"
      }
    }
  }
}
